




































































import Vue from 'vue'
import { Location, LocationStripeConnect, User } from '@/models'
import { mapState } from 'vuex'
import { UserState } from '@/store/state_models'
import {
  updateCachingIndex,
  cacheUpdateEvents,
} from '../../../util/caching.helper'
import { PaymentServices } from '@/services'

let stripeConnectWindow: Window | null
// import AlterTriangle from '@/assets/pmd/img/launchpad/alert-triangle.svg'
import { defineComponent } from '@vue/composition-api'
export default defineComponent({
  props: ['currentLocationId', 'userid'],
  // components:{AlterTriangle},
  data() {
    return {
      sending: false,
      location: {} as Location,
      disableHandler: {
        action: 'stripe',
        disable: false,
      },
    }
  },
  async mounted() {
    this.location = new Location(
      await this.$store.dispatch(
        'locations/getCurrentLocation',
        this.currentLocationId
      )
    )
  },
  computed: {
    ...mapState('user', {
      user: (s: UserState) => {
        return s.user ? new User(s.user) : undefined
      },
    }),
    isStripeConnected() {
      return (
        this.$store.state.stripeConnect.accountId &&
        !this.location?.launchpad?.is_stripe_disconnected
      )
    },
    reconnect():boolean | undefined {
      return this.location?.launchpad?.is_stripe_disconnected
    },
    btnText(): string {
      let btnTxt = 'Connect'
      if (this.reconnect) {
        btnTxt = 'Reconnect'
      }
      return this.sending ? 'Connecting...' : btnTxt
    },
    isAdmin() {
      return this.user && this.user.role == User.ROLE_ADMIN
    },
  },
  methods: {
    async connect() {
      this.disableHandler.disable = true
      this.$root.$emit(
        'disable-launchpad-action',
        JSON.stringify(this.disableHandler)
      )
      this.sending = true
      try {
        const { data } = await PaymentServices.connectStripe({
          locationId: this.location?.id
        })
        stripeConnectWindow = window.open(data.link, '_blank')
        const timer = setInterval(() => {
          if (stripeConnectWindow?.closed) {
            clearInterval(timer)
            this.refreshData()
            this.disableHandler.disable = false
            this.$root.$emit(
              'disable-launchpad-action',
              JSON.stringify(this.disableHandler)
            )
          }
        }, 1000)
      } catch (err) {
        this.disableHandler.disable = false
        this.$root.$emit(
          'disable-launchpad-action',
          JSON.stringify(this.disableHandler)
        )
        this.sending = false
      }
    },
    async refreshData() {
      await updateCachingIndex({
        index_type: cacheUpdateEvents.STRIPE_SETTINGS,
        event_origin: this.location?.id,
      })
      this.$store.dispatch('stripeConnect/syncAll', this.location.id)
      const stripeAccount = await LocationStripeConnect.forLocation(
        this.location.id
      )
      if (stripeAccount) {
        await this.location.ref.update({
          'launchpad.is_stripe_disconnected': false,
        })
        this.location = new Location(
          await this.$store.dispatch(
            'locations/getCurrentLocation',
            this.currentLocationId
          )
        )
      }
      this.sending = false
      this.$root.$emit('launchpad-status')
    },
  },
})
